export default __webpack_public_path__ + "static/media/team4.77fb2cc2.png";